import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IPostMatchState} from "./types";
import { API_POST_MATCH } from "../../../services/api/api.urls";
import { api } from "../../../services/api/api.service";
import {toastr} from "react-redux-toastr";
import { IPostMatchSocketResponse, IScoreBoardPlayersStatistics } from "../scoreboardAndStats/types";
import { COMPANY_ABBR } from "../../../common/constants/company";
import { TryCatch } from "../../../services/TryCatch";

const initialState: IPostMatchState = {
    playersStatistics: {
        statistics:[
            {   totalScore: 0,
                turns100to139: 0,
                turns140to179: 0,
                turns180: 0,
                highestCheckout: 0,
                checkouts100plus: 0,
                average: 0,
                checkoutPercentage: 0,
                checkouts: "",
                totalPoints: 0
            },
            {   totalScore: 0,
                turns100to139: 0,
                turns140to179: 0,
                turns180: 0,
                highestCheckout: 0,
                checkouts100plus: 0,
                average: 0,
                checkoutPercentage: 0,
                checkouts: "",
                totalPoints: 0
            },
        ],
        players:[
            { id: 0 ,name: ""},
            { id: 0 ,name: ""}
        ],
        groups:[]
    } as IScoreBoardPlayersStatistics,
    isLoading: true
}

export const getPostMatchStats = createAsyncThunk<IPostMatchState, void, { rejectValue: string }>(
    'postMatch/get',
    async (_, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(API_POST_MATCH).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, "Post match info failed.");
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const postMatchSlice = createSlice({
    name: 'postMatch',
    reducers: {
        setPostMatchPlayerStatistics: (state, action: PayloadAction<IPostMatchSocketResponse>) => {
            state.playersStatistics.statistics = action.payload.playersStatistics.statistics
            state.playersStatistics.players = action.payload.playersStatistics.players
        }
    },
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getPostMatchStats.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPostMatchStats.fulfilled, (state, action) => {
                state.playersStatistics = action.payload.playersStatistics;
                state.isLoading = false;
            })
            .addCase(getPostMatchStats.rejected, (state) => {
                state.isLoading = false;
            })

    }})

export const {setPostMatchPlayerStatistics} = postMatchSlice.actions;
export default postMatchSlice.reducer;
